/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import {createSelector} from 'reselect';

/**
 * Select all applications available in the Redux store.
 */
const applicationsSelector = state => state.entities.applications.byId;

/**
 * Select the context institution from the Redux store.
 *
 * @param state the Redux state.
 * @returns the context institution id or {null} if not set.
 */
const contextInstitutionSelector = state => state.entities.institutions.contextInstitution;

/**
 * Return applications available to the user.
 */
export const getVisibleApplications = createSelector(
  [applicationsSelector, contextInstitutionSelector],
  (applications, contextInstitution) => {
    const shouldFilter = !contextInstitution;
    let apps = Object.values(applications);

    if (shouldFilter) {
      apps = apps.map((app) => {
        const links = (app.links || []).filter(link => {
          return !link.requiresInstitution;
        });
        return {...app, ...{links: [...links]}};
      }).filter(app => !app.requiresInstitution && app.links.length > 0);
    }
    return apps;
  }
);



// WEBPACK FOOTER //
// ./src/applications/selectors.js